<template>
  <li v-if="(!link.needProfile || link.needProfile.includes(currentUserProfil) || isSuperAdmin) && isEnabled"
      @mouseover="toggleMenu(false)"
      ref="displayMenu"
      :class="{'navigationmain-item' : step === 0, 'is-active': link.routeName === $route.name}">
    <router-link @click.native='changeMenu' v-if="step === 0 && link.routeName" :to="routeWithParam" exact
        :key="link.routeName" disabled
    >
      <span v-if="link.text" @click="toggleMenu">
        <i v-if="link.iconClasses" :class="link.iconClasses"></i>
        <p :class="{'nav-label': link.iconClasses}" class="is-size-6 is-padding-top-xsmall">{{ link.text }}</p>
      </span>
    </router-link>
    <p v-if="step === 1" class="navigationmain-sousmenu-label">
      {{ link.text }}
    </p>
    <router-link @click.native='changeMenu' v-if="step > 1 && link.routeName" :to="routeWithParam" exact
      :key="link.routeName" disabled>
      <span v-if="link.iconClasses">
        <span class="is-pulled-left">{{ link.text }}</span>
        <span class="is-padding-right-small is-pulled-right">
          <i :class="link.iconClasses"></i></span>
      </span>
      <span v-else>{{ link.text }}</span>
      <span class="tag is-notification" v-if="link.badge === 'options'">{{runningOptions.length}}</span>
      <span class="tag is-notification" v-if="link.badge === 'denunciations'">{{runningDenunciations.length}}</span>
      <span class="tag is-notification" v-if="link.badge === 'wishlists'">{{wishlists.length}}</span>
    </router-link>
    
    <div v-if="link.children" @click="toggleMenu(true)"
      :class="{'navigationmain-sousmenu': step === 0, 'navigationmain-sousmenu-list' : step > 0 , 'hide-menu': toggle && step === 0}">
      <display-menu :step="step + 1" :link="link" v-for="(link, i) in link.children"
                    :key="i + '-' + link.routeName"></display-menu>
    </div>
    <a @click.prevent.stop="link.method" v-else-if="link.method" class="">
      <span>{{link.text}}</span>
    </a>
  </li>
</template>

<script>
  import { isNil } from 'lodash'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'display-menu',
    props: {
      link: {
        type: Object,
        required: true
      },
      step: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        params: {},
        toggle: false,
        subMenuEl: null,
        timer: null
      }
    },
    computed: {
      ...mapGetters(['currentUserProfil', 'isSuperAdmin']),
      ...mapState(['runningOptions', 'runningDenunciations', 'wishlists']),
      isEnabled () {
        if (isNil(this.link.configs) || this.link.configs.length === 0) {
          return true
        }
        let enabled = true
        this.link.configs.forEach(config => {
          config = JSON.parse(this.$configs[config])
          if (config === 0 || config === 'false' || config === false) {
            enabled = false
          }
        })
        return enabled
      },
      routeWithParam () {
        return {
          name: this.link.routeName,
          ...this.params
        }
      }
    },
    methods: {
      changeMenu () {
        this.$store.commit('setQuickview', {})
      },
      toggleMenu (val) {
        this.toggle = val
      },
      subMenuCalculPos () {
        if (this.$el && this.$el.querySelector && typeof this.$el.querySelector === 'function') {
          let subMenuEl = this.$el.querySelector(':scope > .navigationmain-sousmenu')
          let wHeight = window.innerHeight
          if (!isNil(subMenuEl)) {
            let subMenuElParent1 = subMenuEl.offsetParent
            let subMenuElParent2 = subMenuElParent1 ? subMenuElParent1.offsetParent : null
            let subMenuElParent3 = subMenuElParent2 ? subMenuElParent2.offsetParent : null
            // Calcul avec le posTop du parent car notre élément est en posAbsolute par rapport à plusieurs parent en posRelatif ou posFixed
            let subMenuPosTop = Math.ceil(
              subMenuEl.offsetTop +
              subMenuElParent1 ? subMenuElParent1.offsetTop : 0 +
              subMenuElParent2 ? subMenuElParent2.offsetTop : 0 +
              subMenuElParent3 ? subMenuElParent3.offsetTop : 0
            )
            let subMenuHeight = subMenuEl.offsetHeight // Hauteur du sous menu
            let totalHeight = Math.ceil(subMenuPosTop + subMenuHeight + 65) // Hauteur total nécessaire pour afficher le sousMenu par rapport à sa position
            let marginTop = (totalHeight > wHeight) ? Math.ceil(wHeight - totalHeight) - 38 + 'px' : 0 // Calcul du marginTop négatif pour faire remonter le menu
            subMenuEl.style.marginTop = marginTop // Application du margin top
          }
        }
      }
    },
    beforeCreate: function () {
      this.$options.components.DisplayMenu = require('./DisplayMenu.vue')
    },
    created () {
      if (this.link && this.link.params) {
        this.params = this.link.params
      }
    },
    mounted () {
      if (this.step === 0) {
        this.subMenuCalculPos()
        window.addEventListener('resize', this.subMenuCalculPos)
      }
    },
    destroyed () {
      if (this.step === 0) {
        window.removeEventListener('resize', this.subMenuCalculPos)
      }
    }
  }
</script>

<style scoped>
  .hide-menu {
    transform: scaleX(0) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/DisplayMenu.vue